// Lazy load product grid images
function lazyLoadpg(){
    var $images = $('.product-grid-image, .lazy-load-image'); 
    $images.each(function(){
        var $img = $(this),
            src = $img.attr('data-src'); 
        $img
            .attr('src',src);
    });
};
// Toggle search, burger, filter menu on mobile
function showSearchBar() {
  $('html').addClass('search-open');
  $('.header-content .search').addClass('active');  
  $('.search form').addClass('visible');  
}
function hideSearchBar() {
  $('html').removeClass('search-open');
  $('.header-content .search').removeClass('active');  
  $('.search form').removeClass('visible');  
}
function showMenu() {
  $('.header-content .burger').addClass('active');
  $('nav').addClass('open');
  $('html').addClass('menu-open');
}
function hideMenu() {
  $('.header-content .burger').removeClass('active');
  $('nav').removeClass('open');
  $('html').removeClass('menu-open');  
  $('.submenu-active').removeClass('submenu-active');
}
function showFilterMenu() {
  $('#filters, .filter-button').addClass('active');
  $('html').addClass('filters-open');
}
function hideFilterMenu() {
  $('#filters, .filter-button').removeClass('active');
  $('html').removeClass('filters-open');  
}
function resetMobMenu() {
  $('ul.submenu-active').removeClass('submenu-active');
  $('.toggle.submenu-active').removeClass('submenu-active');
}
function pianoBannerClose() {
  $('html').removeClass('piano-sold');
  $('.piano-sold-banner').addClass('hide_banner');
}
function rotatePlusIcon(element) {
  $(element).find('#verticalLine').toggleClass('rotated');
}
$( document ).ready(function(){
  lazyLoadpg();
  $('.header-content .burger').on('click',function() {
    if ($(this).hasClass('active')) {
      hideMenu();
    } else {
      showMenu();
      hideSearchBar();
      hideFilterMenu();
    }
  });
  $('.filter-button').on('click',function() {
    if ($(this).hasClass('active')) {
      hideFilterMenu();
    } else {
      showFilterMenu();
      hideSearchBar();
      hideMenu();
    }
  });  
  $('html').on('click',$('#filters > h2 .close'),function(e) {
    if ($(e.target).hasClass('filter-close')) {
      hideFilterMenu();
    }
  });
    $('.header-content:not(.fh):not(.tw):not(.oc) .search').on('click touch',function(e) {
    if ($(window).width() <= 1200 && !($(e.target).parents('#results-box').length)) { // Prevent clicks in results-box triggering
      if ($(this).hasClass('active')) {
        if (!($(e.target).is('#search-input-box')) && !($(e.target).is('#search-input-box ~ button')) && !($(e.target).is('#search-input-box ~ button svg'))) {
          hideSearchBar();
        }
      } else {
        showSearchBar();
        if($(e.target).parents('.header-icons').length) {
          $('#search-input-box').focus();
        }
        hideMenu();
        hideFilterMenu();
      }
    }
}); 
  $('.header-content.tw .search').on('click touch',function(e) {
    if ($(window).width() <= 3000 && !($(e.target).parents('#results-box').length)) {
      if ($(this).hasClass('active')) {
        if (!($(e.target).is('#search-input-box')) && !($(e.target).is('#search-input-box ~ button')) && !($(e.target).is('#search-input-box ~ button svg'))) {
          hideSearchBar();
        }
      } else {
        showSearchBar();
        if($(e.target).parents('.header-icons').length) {
          $('#search-input-box').focus();
        }
        hideMenu();
        hideFilterMenu();
      }
    }
  });
    $('.header-content.oc .search').on('click touch',function(e) {
    if ($(window).width() <= 3000 && !($(e.target).parents('#results-box').length)) {
      if ($(this).hasClass('active')) {
        if (!($(e.target).is('#search-input-box')) && !($(e.target).is('#search-input-box ~ button')) && !($(e.target).is('#search-input-box ~ button svg'))) {
          hideSearchBar();
        }
      } else {
        showSearchBar();
        if($(e.target).parents('.header-icons').length) {
          $('#search-input-box').focus();
        }
        hideMenu();
        hideFilterMenu();
      }
    }
  });
    $('.header-content.fh .search').on('click touch',function(e) {
    if ($(window).width() <= 1000 && !($(e.target).parents('#results-box').length)) { // Prevent clicks in results-box triggering
      if ($(this).hasClass('active')) {
        if (!($(e.target).is('#search-input-box')) && !($(e.target).is('#search-input-box ~ button')) && !($(e.target).is('#search-input-box ~ button svg'))) {
          hideSearchBar();
        }
      } else {
        showSearchBar();
        if($(e.target).parents('.header-icons').length) {
          $('#search-input-box').focus();
        }
        hideMenu();
        hideFilterMenu();
      }
    }
  });
  $('#tint').click(function() {
      hideFilterMenu();
      hideSearchBar();
      hideMenu();
      resetMobMenu();
  });
  $(window).resize(function() {
      hideFilterMenu();
      hideMenu();
      resetMobMenu();
      if ($(window).width() >= 880) {
          hideSearchBar();
      }
  });
});


// Shopify forms styling
document.addEventListener('DOMContentLoaded', () => {
  const formContainer = document.querySelector('#app-embed');

  const observer = new MutationObserver((mutationsList, observer) => {
  const form = document.querySelector('form-embed');

if (form) {
  observer.disconnect();
  const shadow = form.shadowRoot;

  const sheet = new CSSStyleSheet();
  sheet.insertRule(`
    ._formContainer_stahb_30 {
      max-width: 900px!important;
    }
  `);

  shadow.adoptedStyleSheets.push(sheet);
  formContainer.classList.add('loaded');
}
});

observer.observe(document.body, { childList: true, subtree: true });
});


// Paging through mobile menu
$(document).ready(function () {
  $('ul.mega-menu.mobile li .toggle').click(function () {
    if ($(this).hasClass('submenu-active')) {
      $(this).removeClass('submenu-active');
      $(this).parents('.has-sublink').next('ul').removeClass('submenu-active');
    } else {
      $(this).addClass('submenu-active');
      $(this).parents('.has-sublink').next('ul').addClass('submenu-active');
    }
  });
});
//rotate plus icon
$(document).ready(function () {
  $('.plus-icon.toggle').click(function () {
    rotatePlusIcon(this);
  });
});

  
// Trigger the add to cart when pressing enter from the quantity box
$( document ).ready(function(){
  $('#quantity').bind('keypress', function(e) {
      if(e.keyCode==13){
        addToAjaxCart($('#ajax-cart-button'));
      }
  });
});

// Trigger tint for Piano Sold banner
$(document).ready(function() {
  if ($('#add-to-basket').hasClass('piano-sold')) {
    $('html').addClass('piano-sold');
  }
});

// Slick sliders
function productImgSlick() {
  $('#product-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    asNavFor: '#product-images-small',
    mobileFirst:true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 780, 
        settings: {
          dots: false,
          arrows: true
        }
      }
    ]
  });
  $('#product-images-small').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '#product-images',
    dots: false,
    arrows: false,
    mobileFirst: true,
    adaptiveHeight: true,
    focusOnSelect: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 780,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  });  
}
function carouselSlick(e) {
  $(e).slick({    
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: '0px',
    cssEase: 'linear',
    centerMode:true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1243,
        settings: {
          slidesToShow: 4,
    	  slidesToScroll: 4,
          arrows: true,
          dots: false
        }
      },
      {
        breakpoint: 902,
        settings: {
          slidesToShow: 3,
    	  slidesToScroll: 3,
          arrows: true,
          dots: false
        }
      },
      {
        breakpoint: 648,
        settings: {
          slidesToShow: 2,
    	  slidesToScroll: 2,
          arrows:false,
          dots: true
        }
      }
    ]
  });
} 
// Sort an object by key
function sortObjectByKeys(o) {
  return Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
}    
// Update a query parameter
function updateQueryString(k,v) {
  var urlParams = new URLSearchParams(window.location.search);
  urlParams.set(k,v);
  return urlParams.toString().replace(/\+/g,'%20');
}
// Update a query parameter without reloading
function insertUrlParam(key, value) {
  if (history.pushState) {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    window.history.pushState({path: newurl}, '', newurl);
  }
}
// Pad a number with zeroes and change to string
function pad(str,max) {
  str = str.toString();
  return str.length < max ? pad("0" + str, max) : str;
}
// Add commas to numbers
function numberWithCommas(number) {
    var parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (parts.length > 1 && parts[1].toString().length < 2) {
      parts[1] = parts[1].toString() + '0';
    }
    return parts.join(".");
}

async function loadSelectContents(url){
  var dfd = $.Deferred();
  currReqObj = $.ajax({
    url: url,
    data: {
      view: 'variant-select-options'
    },
    dataType: 'html',
    success: function(data){
      console.log(data);
      dfd.resolve(data);
    }
  });
  return dfd.promise();
} 
// Update all the product page info as different variant selected from dropdown
async function updateVariant(newId) {
  var newVar = expanded_variants[newId];  
  var SelectContents = await loadSelectContents('/products/' + newVar.product_handle + '?variant=' + newId);
  $('#variant-selection').html(SelectContents);
  if (newVar.condition_description.length > 0) {
    $('#condition_description').html(newVar.condition_description).show();
    $('#condition_description').addClass(newVar.condition_title);
  } else {
    $('#condition_description').empty().hide();    
  }
  // Load tags from 1000 results for filter population, passed page number
  console.log(newVar);
  // update the sku and variant id
  insertUrlParam('variant',newVar.id);
  $('#variant-info .sku .data').text(newVar.sku);
  if (newVar.title) {
    $('#product-title .variant, #slide-title .variant').text(' - ' + newVar.title);
  } else {
    $('#product-title .variant, #slide-title .variant').text('');    
  }
  $('#variant-id').val(newVar.id);
  // update the main price
  $('#variant-price .data, #slide-variant-price .data, #priceForFinance').text(newVar.price_display);
  $('#variant-price .rrp-discount, #slide-variant-price .rrp-discount').text(newVar.trade_discount);
  // show/hide the exvat price if it's different
  if (newVar.exvat === newVar.price_display) {
    $('#variant-exvat .vat').hide();
  } else {
    $('#variant-exvat .vat').show();
  }
  if (newVar.exvat != newVar.price_display) {
    $('#variant-exvat .data, #slide-variant-exvat').text(newVar.exvat).show();
  } else {
    $('#variant-exvat .data, #slide-variant-exvat').text(newVar.exvat).hide();
  };
  $('#variant-price .sale').text(newVar.flash_sale);

  // update the RRP and show it if it's different from our price
  if (newVar.rrp_display != newVar.price_display  || false) {
  $('#variant-rrp .data').text(newVar.rrp_display).show();
  $('#variant-rrp .label').show();
  } else {
    $('#variant-rrp .data').text(newVar.rrp_display).hide();
    $('#variant-rrp .label').hide();
  }
  if (newVar.rrp_display === 0) {
    $('#variant-rrp .data').hide();
    $('#variant-rrp .label').hide();
  }
   
  // update the stock levels
 $('#variant-stock .data.stock').html(newVar.stock_display);

  if (newVar.pors.length > 0) {
    $('#variant-stock .data.pors').html('<span>' + newVar.pors + '</span>'); 
    $('#variant-stock .data.fromto').html(''); // Hide fromto if pors exists
  } else {
    $('#variant-stock .data.pors span').remove();
    $('#variant-stock .data.fromto').html(newVar.manufacturer_fromto); // Show fromto if no pors
  }

  //Add sheet music bullets 
  $('#sheet-bullet').html(newVar.sheet_bullets).show();
  
  // Update the shipping info
  $('#variant-delivery .data.shipping-group').html(newVar.shipping_group);
  $('#variant-delivery .data.custom-text').text(newVar.custom_text);

  // Show if product is on display 
  if (newVar.on_display === 'true') {
    $('#display-info').html('<img src="https://cdn.shopify.com/s/files/1/0613/0945/2456/t/8/assets/display.jpg">').show();
  } else {
    $('#display-info').html('<img src="https://cdn.shopify.com/s/files/1/0613/0945/2456/t/8/assets/display_not.jpg">').show();
  }

  // Update min purchase 
   if (newVar.min_purchase && newVar.min_purchase !== "0") {
        $('#quantity').val(newVar.min_purchase);
        $('.min-purchase')
            .html(`<strong>Minimum purchase: ${newVar.min_purchase}</strong>`)
            .show(); 
    } else {
        $('#quantity').val(1);
        $('.min-purchase').hide(); 
    }if (newVar.qbreakString && newVar.qbreakString.trim() !== "") {
        // Parse the HTML string into a jQuery object
        var htmlString = newVar.qbreakString;
        var $breaks = $(htmlString);    
        // Sort the divs based on the quantity
        $breaks.sort(function(a, b) {
            // Extract the quantity from the spans
            var quantityA = parseInt($(a).find('.quantity').text());
            var quantityB = parseInt($(b).find('.quantity').text());    
            // Sort in ascending order
            return quantityA - quantityB;
        });    
        // Update the HTML of the quantity-breaks element with sorted divs
        $('#quantity-breaks').html($breaks);
    } else {
      $('#quantity-breaks').html(newVar.qbreakString);
    }// build the image html from a list of URLs
  $('#product-images').has('.slick-slide').slick('unslick');
  $('#product-images').empty();
  $('#product-images-small').has('.slick-slide').slick('unslick');
  $('#product-images-small').empty();
  let media_tally = 0;
  let thumb_tally = 0;
  $.each(newVar.images, function(i,e){      
    $('#product-images').append('<div class="slide" data-slide-number="' + media_tally + '"><div class="fullscreen-button"></div><img src="' + e.url + '" alt="' + e.alt + '" style="aspect-ratio:' + e.aspect + ';"></div>');
    media_tally = media_tally + 1;
  });
  $.each(newVar.thumbs, function(i,e){
    $('#product-images-small').append('<div class="slide" data-slide-number="' + thumb_tally + '"><img src="' + e.url + '" alt="' + e.alt + '" style="aspect-ratio:' + e.aspect + ';"></div>');
    thumb_tally = thumb_tally + 1;
  });
  $.each(newVar.videos, function(i,e){
    $('#product-images').append('<div class="slide video" data-slide-number="' + media_tally + '"><div class="video-spacer">' + e.code + '</div></div>');
    $('#product-images-small').append('<div class="slide video-thumb" data-slide-number="' + thumb_tally + '"><img src="' + e.url + '" alt="' + e.alt + '"></div>');
    media_tally = media_tally + 1;
    thumb_tally = thumb_tally + 1;
  });
  productImgSlick();
  $('#images .fullscreen-button').attr('onclick','photoswipe(\'' + newVar.id + '\');');
  // replace linked variant blocks
  $('#recommended-accessories').empty();
  $('#recommended-accessories').append(newVar.linked_variants);
  if (newVar.linked_variants.length > 0) {
    $('#recommended-header').show();
  } else {
    $('#recommended-header').hide();
  }
  // replace crosssell variant blocks
  $('#promos .recommendation').remove();
  if (newVar.crosssell_variant.length > 0 && $('#promos .promo-graphic').length > 0) {
    $('#promos .promo-graphic').before(newVar.crosssell_variant);
  } else if (newVar.crosssell_variant.length > 0) {
    $('#promos').append(newVar.crosssell_variant);
  }
   $('#prod-usp .free-delivery').hide();
  console.log(newVar);
  if (newVar.price >= 5000 && newVar.shipping_group == '' ) {
      $('#prod-usp .free-delivery').show();
  } 
   $('#prod-usp .despatch').hide();
  console.log(newVar);
  if (newVar.stock_level > 0 ) {
      $('#prod-usp .despatch').show();
  } 
  // replace similar items carousel contents
  $('.product-carousel.similar-items').has('.slick-slide').slick('unslick');
  $('.product-carousel.similar-items').empty();
  $('.product-carousel.similar-items').append(newVar.similar_items);
  carouselSlick('.product-carousel.similar-items');
  lazyLoadpg();
}

// Add download icon to piano manuals
$( document ).ready(function(){
    var $links = $('.piano-manual-in-description, .manual-in-description, .dealer-assets').not('.sxp');
    $links.each(function(){ 
      $(this).append('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" class="rollover-block" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 19.54 14.57" style="enable-background:new 0 0 19.54 14.57;" xml:space="preserve"><g><g><g><polygon points="9.77,10.97 0,1.2 1.2,0 9.77,8.57 18.34,0 19.54,1.2"/></g></g><g><rect x="0.26" y="12.87" width="19.03" height="1.7"/></g></g></svg>');
    });
});

$( document ).ready(function(){
    var $links = $('.manual-in-description.sxp');
    $links.each(function(){ 
      $(this).append('<svg version="1.1" x="0px" y="0px" width="12px" class="rollover-block" height="20.5px" viewBox="0 0 12 20.5" style="enable-background:new 0 0 12 20.5;" xml:space="preserve"> <g> <g> <polygon points="1.7,20 0.5,18.8 9.1,10.3 0.5,1.7 1.7,0.5 11.5,10.3 "/> </g> </g> </svg>');
    });
});

// function for carousel slick initialization
function carouselSlick(selector) {
    $(selector).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        responsive: [
            {
                breakpoint: 1324,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false,
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            }
        ]
    });
}

// function for adding to cart
function addToAjaxCart(button) {
  button.html('<img src="//www.chamberlainpianos.co.uk/cdn/shop/t/4/assets/preloader.gif?v=77008736554601496081732186582">');
  var quantity = $('#quantity').val(),
      variantid = $('#variant-id').val(),
      stocklevel = expanded_variants[variantid].stock_level,
      overselling = expanded_variants[variantid].stock_policy,
      qbreaks = expanded_variants[variantid].quantity_breaks;
  if (overselling == 'deny' && quantity > stocklevel) {
    quantity = stocklevel;
  }
  const params = {
    "items": [{
      "id": variantid,
      "quantity": quantity,
      "properties": {
        "_stocklevel": stocklevel,
        "_qbreaks": qbreaks
      }
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params)
  })
  .then(response => {   
    if (response.status == 422 && overselling == 'deny') {
      button.css('display','none');
      $('#fading-message').html('<span>You have all our remaining stock in your basket</span><a class="button" href="/cart">Go to basket</a>').addClass('show red');
    } else {
      if (button[0].id == 'slide-ajax-cart-button') {
        window.location.replace('/cart');
      } else {
        button.html('Add to basket'); 
        $('#fading-message').html('<span>Item added to basket</span><a class="button" href="/cart">Go to basket</a>').addClass('show');
        setTimeout(function() {
          $('#fading-message').removeClass('show');
        }, 6000);
        jQuery.get('/cart.js',function(data) {
            $('#basket-contents-number').css('display','flex').text(data.item_count);
            var price_display = 0;
            let to_add = 0;
            $(data.items).each(function(i,l) {
              var actual_price_ex = l.price;
              $(l.properties['_qbreaks']).each(function(i,q) {
                let qty = q.split(':')[0] * 1;
                let pri = q.split(':')[1].replace('£','') * 100;
                console.log([pri,qty,l.quantity]);                
                if (l.quantity > qty) {
                  actual_price_ex = pri;
                }
              });
              console.log(actual_price_ex);
              
                if (l.taxable) {
                  to_add = Math.round(actual_price_ex * l.quantity * 1.2);
                } else {
                  to_add = actual_price_ex * l.quantity;
                }
              
              price_display = price_display + to_add;
            });
            price_display = price_display/100.00;
            price_display = numberWithCommas(price_display);
            $('#basket-total-cost').text('£' + price_display);
        },'json');
        return response.json();    
      }
    } 
  })
  .catch((error) => {
    console.error('Error:', error);
  });          
}